<template>
    <div
        v-if="terms.length"
        class="af-terms afu-my-2"
    >
        <div
            v-for="term in terms"
            :key="term.id"
            class="af-terms-list afu-mb-2"
        >
            <template v-if="term.display_checkbox">
                <ValidationProvider
                    :vid="`Term${term.id}`"
                    :name="`Term${term.id}`"
                    :rules="{ required: { allowFalse: term.required_field ? false : true } }"
                    v-slot="{ errors }"
                >
                    <div class="af-terms-list-item">
                        <span>
                            <input
                                type="checkbox"
                                :name="`Term${term.id}`"
                                :id="`Term${term.id}`"
                                :key="`Term${term.id}`"
                                :value="`Term${term.id}`"
                                v-model="term.prechecked"
                            >
                        </span>
                        <span
                            class="afu-pl-2"
                            v-html="term.content"
                        />
                    </div>
                    <small
                        v-if="errors.length"
                        :key="`Term${term.id}`"
                        class="af-help-text afu-block afu-text-danger-400"
                    >
                        {{ $t('terms.validation_message') }}
                    </small>
                </ValidationProvider>
            </template>
            <template v-else>
                <div class="af-terms-list-item">
                    <span
                        class="afu-pl-2"
                        v-html="term.content"
                    />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { ValidationProvider } from 'vee-validate';

    export default {
        name: 'AfTerms',

        components: {
            ValidationProvider,
        },

        data() {
            return {};
        },

        props: {
            terms: {
                type: Array,
                default: () => [],
            },
        },

        computed: {},

        created() {},
    };
</script>
